module.exports = __webpack_public_path__ + "img/receta.6b8ede9b.svg";